import { colors } from './colors';

const sizes = {
    standardCheckboxColWidth: '36px',
    headerHeight: '70px',
    col1Width: '260px',
    col2MaxWidth: '1450px',
    layoutGap: '8px',
};

const allVariables = {
    ...sizes,
    ...colors,
    border: `1px solid ${colors.defaultBorder}`,
};

const prefixedVariables = {};
for (const key in allVariables) {
    prefixedVariables[`--${key}`] = allVariables[key];
}

export { sizes, colors, prefixedVariables };
